var map = {
	"./": 22974,
	"./App": 86595,
	"./App.tsx": 86595,
	"./assets/images/app_icon.png": 98604,
	"./assets/images/app_icon_without_title.png": 50298,
	"./assets/images/appstore_icon.png": 95359,
	"./assets/images/black_bg_logo.jpeg": 63511,
	"./assets/images/file-picker-placeholder.png": 79206,
	"./assets/images/game_ended_bg_image.jpeg": 33007,
	"./assets/images/gswf_sponsor_image.png": 5631,
	"./assets/images/icon_transparent.PNG": 64728,
	"./assets/images/instagram_logo.png": 65057,
	"./assets/images/lifelines/call_a_friend.png": 54118,
	"./assets/images/lifelines/double_points.png": 74310,
	"./assets/images/lifelines/extra_time.png": 91711,
	"./assets/images/lifelines/insurance.png": 7145,
	"./assets/images/lifelines/tie_breaker.png": 30674,
	"./assets/images/lifelines/trap.png": 19248,
	"./assets/images/lifelines/two_answers.png": 3871,
	"./assets/images/login-bg-image.jpg": 29130,
	"./assets/images/marron_writing_logo.png": 47597,
	"./assets/images/minus_icon.png": 93611,
	"./assets/images/placeholder.jpg": 27472,
	"./assets/images/platina_gif.gif": 28924,
	"./assets/images/platina_logo_sponsor.png": 9371,
	"./assets/images/playstore_icon.png": 7908,
	"./assets/images/plus_icon.png": 68403,
	"./assets/images/q_wave.gif": 94611,
	"./assets/images/q_wave_image1.png": 20505,
	"./assets/images/q_wave_image2 copy.png": 56683,
	"./assets/images/q_wave_image2.png": 80770,
	"./assets/images/q_wave_image3.png": 1899,
	"./assets/images/rodeo_sponsor_image.png": 71773,
	"./assets/images/white_writing_logo.png": 93787,
	"./assets/sounds/Correct/250_Question/Coin.wav": 61704,
	"./assets/sounds/Correct/250_Question/PopBells.mp3": 35886,
	"./assets/sounds/Correct/250_Question/correct.mp3": 11251,
	"./assets/sounds/Correct/500_Questions/AppMoney1.mp3": 85322,
	"./assets/sounds/Correct/500_Questions/AppMoney2.mp3": 23325,
	"./assets/sounds/Correct/500_Questions/CashMachine.mp3": 15850,
	"./assets/sounds/Correct/500_Questions/GlockSuccessDing.mp3": 58229,
	"./assets/sounds/Correct/750_Questions/MoneyCoins1.mp3": 35640,
	"./assets/sounds/Correct/750_Questions/MoneyCoins2.mp3": 51887,
	"./assets/sounds/Correct/750_Questions/PopWin1.mp3": 72149,
	"./assets/sounds/Correct/750_Questions/PopWin2.mp3": 62370,
	"./assets/sounds/Correct/Double_Points/250_Question/GamePops1.mp3": 68776,
	"./assets/sounds/Correct/Double_Points/250_Question/GamePops3.wav": 5062,
	"./assets/sounds/Correct/Double_Points/500_Questions/DigitalLoading.mp3": 38888,
	"./assets/sounds/Correct/Double_Points/500_Questions/DigitalText.wav": 44281,
	"./assets/sounds/Correct/Double_Points/500_Questions/GamePops2.mp3": 71528,
	"./assets/sounds/Correct/Double_Points/750_Question/CorrectAnswerRings.mp3": 75453,
	"./assets/sounds/Correct/Pit/250_Question/GamePops4.wav": 58377,
	"./assets/sounds/Correct/Pit/500_Questions/GamePops5.wav": 87039,
	"./assets/sounds/Correct/Pit/500_Questions/StrongPunch2.wav": 98999,
	"./assets/sounds/Correct/Pit/500_Questions/SwordSlashA.mp3": 27139,
	"./assets/sounds/Correct/Pit/750_Question/GamePops6.wav": 82548,
	"./assets/sounds/Correct/Pit/750_Question/PopPoppingDown.wav": 62758,
	"./assets/sounds/EndGame/1000_2000_Difference/HappyFanfare.mp3": 92799,
	"./assets/sounds/EndGame/1000_2000_Difference/WinFanfare.wav": 30751,
	"./assets/sounds/EndGame/1000_2000_Difference/Winning.mp3": 65762,
	"./assets/sounds/EndGame/2250_2750_Difference/MoneyWinner.wav": 6767,
	"./assets/sounds/EndGame/250_750_difference/Win1.mp3": 54065,
	"./assets/sounds/EndGame/3000_Difference/Easy_Money_Alert_TTX020704.wav": 24245,
	"./assets/sounds/EndGame/Tie/Sword.wav": 11163,
	"./assets/sounds/Selected_Lifeline/Additional_Time/ClockMechanism.wav": 90085,
	"./assets/sounds/Selected_Lifeline/Call_A_friend/Cell_Phone.wav": 76807,
	"./assets/sounds/Selected_Lifeline/Call_A_friend/Phone_Ring.wav": 68507,
	"./assets/sounds/Selected_Lifeline/Call_A_friend/TelephoneRing1.wav": 73005,
	"./assets/sounds/Selected_Lifeline/Call_A_friend/TelephoneRing2.wav": 43906,
	"./assets/sounds/Selected_Lifeline/Call_A_friend/TelephoneRing3.wav": 99003,
	"./assets/sounds/Selected_Lifeline/Double_points/Powerup.wav": 42538,
	"./assets/sounds/Selected_Lifeline/Insurance/sHIELD.wav": 92624,
	"./assets/sounds/Selected_Lifeline/Pit/Shovel.wav": 87491,
	"./assets/sounds/Selected_Lifeline/Pop.wav": 98385,
	"./assets/sounds/Timer/FastTick.wav": 65914,
	"./assets/sounds/Timer/TimeIsUp.mp3": 93899,
	"./assets/sounds/Timer/TimerTicks.mp3": 77856,
	"./assets/sounds/Wrong/250_Question/Fart.mp3": 91355,
	"./assets/sounds/Wrong/250_Question/WrongAnswer2.wav": 40947,
	"./assets/sounds/Wrong/Wrong.wav": 61470,
	"./assets/sounds/Wrong/WrongAnswer.mp3": 72344,
	"./assets/sounds/Wrong/WrongAnswer2.wav": 41486,
	"./assets/sounds/Wrong/WrongOption1.mp3": 15730,
	"./assets/sounds/XAnswered/Pop.wav": 74166,
	"./core/utils/SharedPreferences": 47291,
	"./core/utils/SharedPreferences.ts": 47291,
	"./core/utils/UseExitPrompt": 74591,
	"./core/utils/UseExitPrompt.ts": 74591,
	"./core/utils/UseWindowDimensions": 25920,
	"./core/utils/UseWindowDimensions.ts": 25920,
	"./core/utils/Utils": 71452,
	"./core/utils/Utils.ts": 71452,
	"./core/utils/UtilsInJS": 11825,
	"./core/utils/UtilsInJS.js": 11825,
	"./data/api/ApiService": 55861,
	"./data/api/ApiService.ts": 55861,
	"./data/api/AxiosBuilder": 2623,
	"./data/api/AxiosBuilder.ts": 2623,
	"./data/api/ErrorResponse": 61069,
	"./data/api/ErrorResponse.ts": 61069,
	"./data/api/Response": 32509,
	"./data/api/Response.ts": 32509,
	"./data/colors/Colors": 97186,
	"./data/colors/Colors.ts": 97186,
	"./data/constant/ApiConstants": 61391,
	"./data/constant/ApiConstants.ts": 61391,
	"./data/constant/Constants": 92613,
	"./data/constant/Constants.ts": 92613,
	"./data/constant/RouteConstants": 4772,
	"./data/constant/RouteConstants.ts": 4772,
	"./data/network/NetworkApi": 27178,
	"./data/network/NetworkApi.ts": 27178,
	"./data/network/NetworkApiImpl": 556,
	"./data/network/NetworkApiImpl.ts": 556,
	"./data/repository/answer/AnswerRepository": 96125,
	"./data/repository/answer/AnswerRepository.ts": 96125,
	"./data/repository/answer/AnswerRepositoryImpl": 56787,
	"./data/repository/answer/AnswerRepositoryImpl.ts": 56787,
	"./data/repository/auth/AuthRepository": 59441,
	"./data/repository/auth/AuthRepository.ts": 59441,
	"./data/repository/auth/AuthRepositoryImpl": 48439,
	"./data/repository/auth/AuthRepositoryImpl.ts": 48439,
	"./data/repository/category/CategoryRepository": 75509,
	"./data/repository/category/CategoryRepository.ts": 75509,
	"./data/repository/category/CategoryRepositoryImpl": 43995,
	"./data/repository/category/CategoryRepositoryImpl.ts": 43995,
	"./data/repository/discountCode/DiscountCodeRepository": 90017,
	"./data/repository/discountCode/DiscountCodeRepository.ts": 90017,
	"./data/repository/discountCode/DiscountCodeRepositoryImpl": 84807,
	"./data/repository/discountCode/DiscountCodeRepositoryImpl.ts": 84807,
	"./data/repository/game/GameRepository": 1709,
	"./data/repository/game/GameRepository.ts": 1709,
	"./data/repository/game/GameRepositoryImpl": 54755,
	"./data/repository/game/GameRepositoryImpl.ts": 54755,
	"./data/repository/package/PackageRepository": 78779,
	"./data/repository/package/PackageRepository.ts": 78779,
	"./data/repository/package/PackageRepositoryImpl": 6865,
	"./data/repository/package/PackageRepositoryImpl.ts": 6865,
	"./data/repository/payment/PaymentRepository": 76047,
	"./data/repository/payment/PaymentRepository.ts": 76047,
	"./data/repository/payment/PaymentRepositoryImpl": 4501,
	"./data/repository/payment/PaymentRepositoryImpl.ts": 4501,
	"./data/repository/player/PlayerRepository": 25759,
	"./data/repository/player/PlayerRepository.ts": 25759,
	"./data/repository/player/PlayerRepositoryImpl": 97637,
	"./data/repository/player/PlayerRepositoryImpl.ts": 97637,
	"./data/repository/qrcode/QRCodeRepository": 96461,
	"./data/repository/qrcode/QRCodeRepository.ts": 96461,
	"./data/repository/qrcode/QRCodeRepositoryImpl": 77571,
	"./data/repository/qrcode/QRCodeRepositoryImpl.ts": 77571,
	"./data/repository/question/QuestionRepository": 77881,
	"./data/repository/question/QuestionRepository.ts": 77881,
	"./data/repository/question/QuestionRepositoryImpl": 93551,
	"./data/repository/question/QuestionRepositoryImpl.ts": 93551,
	"./data/repository/sound/SoundRepository": 37271,
	"./data/repository/sound/SoundRepository.ts": 37271,
	"./data/repository/transaction/TransactionRepository": 69955,
	"./data/repository/transaction/TransactionRepository.ts": 69955,
	"./data/repository/transaction/TransactionRepositoryImpl": 5929,
	"./data/repository/transaction/TransactionRepositoryImpl.ts": 5929,
	"./data/repository/uploadFIle/UploadFileRepository": 3755,
	"./data/repository/uploadFIle/UploadFileRepository.ts": 3755,
	"./data/repository/uploadFIle/UploadFileRepositoryImpl": 40289,
	"./data/repository/uploadFIle/UploadFileRepositoryImpl.ts": 40289,
	"./data/strings/Strings": 36388,
	"./data/strings/Strings.ts": 36388,
	"./domain/model/Attachment": 15756,
	"./domain/model/Attachment.ts": 15756,
	"./domain/model/Auth": 48767,
	"./domain/model/Auth.ts": 48767,
	"./domain/model/Category": 64257,
	"./domain/model/Category.ts": 64257,
	"./domain/model/DiscountCode": 94627,
	"./domain/model/DiscountCode.ts": 94627,
	"./domain/model/Game": 10963,
	"./domain/model/Game.ts": 10963,
	"./domain/model/Lifeline": 78665,
	"./domain/model/Lifeline.ts": 78665,
	"./domain/model/Package": 3785,
	"./domain/model/Package.ts": 3785,
	"./domain/model/Payment": 62799,
	"./domain/model/Payment.ts": 62799,
	"./domain/model/QRCode": 54939,
	"./domain/model/QRCode.ts": 54939,
	"./domain/model/Question": 87637,
	"./domain/model/Question.ts": 87637,
	"./domain/model/ResponseState": 34553,
	"./domain/model/ResponseState.ts": 34553,
	"./domain/model/Stats": 85730,
	"./domain/model/Stats.ts": 85730,
	"./domain/model/Transaction": 61905,
	"./domain/model/Transaction.ts": 61905,
	"./domain/model/User": 39906,
	"./domain/model/User.ts": 39906,
	"./domain/usecase/answer/get/GetUseCase": 28646,
	"./domain/usecase/answer/get/GetUseCase.ts": 28646,
	"./domain/usecase/answer/getByQuestionId/GetByQuestionIdUseCase": 20750,
	"./domain/usecase/answer/getByQuestionId/GetByQuestionIdUseCase.ts": 20750,
	"./domain/usecase/auth/CheckVerificationCode/UseCase": 27348,
	"./domain/usecase/auth/CheckVerificationCode/UseCase.ts": 27348,
	"./domain/usecase/auth/ForgotPassword/UseCase": 79834,
	"./domain/usecase/auth/ForgotPassword/UseCase.ts": 79834,
	"./domain/usecase/auth/Login/LoginUseCase": 4882,
	"./domain/usecase/auth/Login/LoginUseCase.ts": 4882,
	"./domain/usecase/auth/LoginAsGuest/UseCase": 78819,
	"./domain/usecase/auth/LoginAsGuest/UseCase.ts": 78819,
	"./domain/usecase/auth/LoginByUID/UseCase": 87518,
	"./domain/usecase/auth/LoginByUID/UseCase.ts": 87518,
	"./domain/usecase/auth/ResetPassword/UseCase": 68648,
	"./domain/usecase/auth/ResetPassword/UseCase.ts": 68648,
	"./domain/usecase/auth/SendVerificationCode/UseCase": 83708,
	"./domain/usecase/auth/SendVerificationCode/UseCase.ts": 83708,
	"./domain/usecase/auth/Signup/SignupUseCase": 58592,
	"./domain/usecase/auth/Signup/SignupUseCase.ts": 58592,
	"./domain/usecase/category/getAll/GetAllUseCase": 82672,
	"./domain/usecase/category/getAll/GetAllUseCase.ts": 82672,
	"./domain/usecase/category/getUnlockCode/UseCase": 82721,
	"./domain/usecase/category/getUnlockCode/UseCase.ts": 82721,
	"./domain/usecase/category/unlock/UseCase": 43342,
	"./domain/usecase/category/unlock/UseCase.ts": 43342,
	"./domain/usecase/discountCode/checkIfRedeemable/UseCase": 15149,
	"./domain/usecase/discountCode/checkIfRedeemable/UseCase.ts": 15149,
	"./domain/usecase/discountCode/redeem/UseCase": 83864,
	"./domain/usecase/discountCode/redeem/UseCase.ts": 83864,
	"./domain/usecase/game/update/UseCase": 52813,
	"./domain/usecase/game/update/UseCase.ts": 52813,
	"./domain/usecase/package/getAll/GetAllUseCase": 57008,
	"./domain/usecase/package/getAll/GetAllUseCase.ts": 57008,
	"./domain/usecase/payment/execute/UseCase": 22297,
	"./domain/usecase/payment/execute/UseCase.ts": 22297,
	"./domain/usecase/payment/initiate/UseCase": 73923,
	"./domain/usecase/payment/initiate/UseCase.ts": 73923,
	"./domain/usecase/payment/status/UseCase": 60854,
	"./domain/usecase/payment/status/UseCase.ts": 60854,
	"./domain/usecase/player/AddToGames/AddToGamesUseCase": 46959,
	"./domain/usecase/player/AddToGames/AddToGamesUseCase.ts": 46959,
	"./domain/usecase/player/AddToHistory/AddToHistoryUseCase": 34429,
	"./domain/usecase/player/AddToHistory/AddToHistoryUseCase.ts": 34429,
	"./domain/usecase/player/AddToUnfinishedGames/UseCase": 73867,
	"./domain/usecase/player/AddToUnfinishedGames/UseCase.ts": 73867,
	"./domain/usecase/player/DeleteAccount/UseCase": 74411,
	"./domain/usecase/player/DeleteAccount/UseCase.ts": 74411,
	"./domain/usecase/player/GameStarted/GameStartedUseCase": 99847,
	"./domain/usecase/player/GameStarted/GameStartedUseCase.ts": 99847,
	"./domain/usecase/player/GetCategoriesStats/GetCategoriesStatsUseCase": 41271,
	"./domain/usecase/player/GetCategoriesStats/GetCategoriesStatsUseCase.ts": 41271,
	"./domain/usecase/player/GetCurrentGames/GetCurrentGamesUseCase": 23891,
	"./domain/usecase/player/GetCurrentGames/GetCurrentGamesUseCase.ts": 23891,
	"./domain/usecase/player/GetCurrentInfo/GetCurrentInfoUseCase": 7659,
	"./domain/usecase/player/GetCurrentInfo/GetCurrentInfoUseCase.ts": 7659,
	"./domain/usecase/player/GetCurrentReferralUnlockedCodes/GetCurrentReferralUnlockedCodesUseCase": 38727,
	"./domain/usecase/player/GetCurrentReferralUnlockedCodes/GetCurrentReferralUnlockedCodesUseCase.ts": 38727,
	"./domain/usecase/player/RemoveFromUnfinishedGames/UseCase": 32649,
	"./domain/usecase/player/RemoveFromUnfinishedGames/UseCase.ts": 32649,
	"./domain/usecase/player/ResetQuestions/ResetQuestionsUseCase": 44253,
	"./domain/usecase/player/ResetQuestions/ResetQuestionsUseCase.ts": 44253,
	"./domain/usecase/player/Update/UpdateUseCase": 67555,
	"./domain/usecase/player/Update/UpdateUseCase.ts": 67555,
	"./domain/usecase/qrcode/generate/UseCase": 74635,
	"./domain/usecase/qrcode/generate/UseCase.ts": 74635,
	"./domain/usecase/question/getNumberOfRemainingQuestions/GetNumberOfRemainingQuestionsUseCase": 98072,
	"./domain/usecase/question/getNumberOfRemainingQuestions/GetNumberOfRemainingQuestionsUseCase.ts": 98072,
	"./domain/usecase/question/getRandomQuestion/GetRandomQuestionUseCase": 33520,
	"./domain/usecase/question/getRandomQuestion/GetRandomQuestionUseCase.ts": 33520,
	"./domain/usecase/question/giveAnswer/QuestionGiveAnswerUseCase": 16660,
	"./domain/usecase/question/giveAnswer/QuestionGiveAnswerUseCase.ts": 16660,
	"./domain/usecase/question/giveRating/QuestionGiveRatingUseCase": 91070,
	"./domain/usecase/question/giveRating/QuestionGiveRatingUseCase.ts": 91070,
	"./domain/usecase/stats/games/get/GetStatsUseCase": 6914,
	"./domain/usecase/stats/games/get/GetStatsUseCase.ts": 6914,
	"./domain/usecase/stats/players/GetStatsUseCase": 41928,
	"./domain/usecase/stats/players/GetStatsUseCase.ts": 41928,
	"./domain/usecase/stats/transactions/GetStatsUseCase": 10459,
	"./domain/usecase/stats/transactions/GetStatsUseCase.ts": 10459,
	"./domain/usecase/transaction/create/CreateUseCase": 33046,
	"./domain/usecase/transaction/create/CreateUseCase.ts": 33046,
	"./domain/usecase/transaction/getAll/GetAllUseCase": 89156,
	"./domain/usecase/transaction/getAll/GetAllUseCase.ts": 89156,
	"./domain/usecase/uploadFile/UploadFileUseCase": 99549,
	"./domain/usecase/uploadFile/UploadFileUseCase.ts": 99549,
	"./domain/validation/Validation": 65048,
	"./domain/validation/Validation.ts": 65048,
	"./i18n/config": 29334,
	"./i18n/config.ts": 29334,
	"./i18n/useLocalizeDocumentAttributes": 88955,
	"./i18n/useLocalizeDocumentAttributes.ts": 88955,
	"./index": 22974,
	"./index.tsx": 22974,
	"./presentation/component/404View": 75293,
	"./presentation/component/404View.tsx": 75293,
	"./presentation/component/AutoHeightView": 75052,
	"./presentation/component/AutoHeightView.tsx": 75052,
	"./presentation/component/CustomAlertDialog": 12920,
	"./presentation/component/CustomAlertDialog.tsx": 12920,
	"./presentation/component/CustomButtonView": 17283,
	"./presentation/component/CustomButtonView.tsx": 17283,
	"./presentation/component/CustomCardView": 15253,
	"./presentation/component/CustomCardView.tsx": 15253,
	"./presentation/component/CustomImageView": 2162,
	"./presentation/component/CustomImageView.tsx": 2162,
	"./presentation/component/CustomPopoverView": 16218,
	"./presentation/component/CustomPopoverView.tsx": 16218,
	"./presentation/component/CustomSwitchView": 26277,
	"./presentation/component/CustomSwitchView.tsx": 26277,
	"./presentation/component/CustomTextField": 12364,
	"./presentation/component/CustomTextField.tsx": 12364,
	"./presentation/component/CustomTextView": 62462,
	"./presentation/component/CustomTextView.tsx": 62462,
	"./presentation/component/CustomTitledView": 48701,
	"./presentation/component/CustomTitledView.tsx": 48701,
	"./presentation/component/EmptyView": 96785,
	"./presentation/component/EmptyView.tsx": 96785,
	"./presentation/component/FilePicker": 62485,
	"./presentation/component/FilePicker.tsx": 62485,
	"./presentation/component/GiveFeedbackDialog": 24547,
	"./presentation/component/GiveFeedbackDialog.tsx": 24547,
	"./presentation/component/HeaderView": 13557,
	"./presentation/component/HeaderView.tsx": 13557,
	"./presentation/component/HorizontalOnlyContainer": 21418,
	"./presentation/component/HorizontalOnlyContainer.tsx": 21418,
	"./presentation/component/LifelinesView": 89357,
	"./presentation/component/LifelinesView.tsx": 89357,
	"./presentation/component/LoadingView": 38186,
	"./presentation/component/LoadingView.tsx": 38186,
	"./presentation/component/NotistackWrapper": 79780,
	"./presentation/component/NotistackWrapper.tsx": 79780,
	"./presentation/component/TitleView": 15148,
	"./presentation/component/TitleView.tsx": 15148,
	"./presentation/di/NetworkModule": 5729,
	"./presentation/di/NetworkModule.ts": 5729,
	"./presentation/di/UseCasesModule": 77747,
	"./presentation/di/UseCasesModule.ts": 77747,
	"./presentation/pages/auth/forgotPassword/ForgotPasswordView": 63717,
	"./presentation/pages/auth/forgotPassword/ForgotPasswordView.tsx": 63717,
	"./presentation/pages/auth/forgotPassword/ForgotPasswordViewModel": 87482,
	"./presentation/pages/auth/forgotPassword/ForgotPasswordViewModel.ts": 87482,
	"./presentation/pages/auth/login/LoginForm": 26790,
	"./presentation/pages/auth/login/LoginForm.tsx": 26790,
	"./presentation/pages/auth/login/LoginView": 93463,
	"./presentation/pages/auth/login/LoginView.tsx": 93463,
	"./presentation/pages/auth/login/LoginViewModel": 80312,
	"./presentation/pages/auth/login/LoginViewModel.ts": 80312,
	"./presentation/pages/auth/resetPassword/ResetPasswordView": 40027,
	"./presentation/pages/auth/resetPassword/ResetPasswordView.tsx": 40027,
	"./presentation/pages/auth/resetPassword/ResetPasswordViewModel": 15572,
	"./presentation/pages/auth/resetPassword/ResetPasswordViewModel.ts": 15572,
	"./presentation/pages/auth/signup/SignupForm": 20236,
	"./presentation/pages/auth/signup/SignupForm.tsx": 20236,
	"./presentation/pages/auth/signup/SignupView": 34157,
	"./presentation/pages/auth/signup/SignupView.tsx": 34157,
	"./presentation/pages/auth/signup/SignupViewModel": 15874,
	"./presentation/pages/auth/signup/SignupViewModel.ts": 15874,
	"./presentation/pages/choosePackage/ChoosePackageView": 78004,
	"./presentation/pages/choosePackage/ChoosePackageView.tsx": 78004,
	"./presentation/pages/choosePackage/ChoosePackageViewModel": 50109,
	"./presentation/pages/choosePackage/ChoosePackageViewModel.ts": 50109,
	"./presentation/pages/choosePackage/payment/PaymentView": 66625,
	"./presentation/pages/choosePackage/payment/PaymentView.tsx": 66625,
	"./presentation/pages/choosePackage/payment/PaymentViewModel": 14749,
	"./presentation/pages/choosePackage/payment/PaymentViewModel.ts": 14749,
	"./presentation/pages/dashboard/DashboardView": 11703,
	"./presentation/pages/dashboard/DashboardView.tsx": 11703,
	"./presentation/pages/dashboard/DashboardViewModel": 44933,
	"./presentation/pages/dashboard/DashboardViewModel.ts": 44933,
	"./presentation/pages/game/GameFinishedView": 39586,
	"./presentation/pages/game/GameFinishedView.tsx": 39586,
	"./presentation/pages/game/GameView": 68534,
	"./presentation/pages/game/GameView.tsx": 68534,
	"./presentation/pages/game/GameViewModel": 82823,
	"./presentation/pages/game/GameViewModel.ts": 82823,
	"./presentation/pages/game/question/CharadesCategoryView": 37486,
	"./presentation/pages/game/question/CharadesCategoryView.tsx": 37486,
	"./presentation/pages/game/question/QuestionAnswerDetailsView": 11749,
	"./presentation/pages/game/question/QuestionAnswerDetailsView.tsx": 11749,
	"./presentation/pages/game/question/QuestionMobileView": 73123,
	"./presentation/pages/game/question/QuestionMobileView.tsx": 73123,
	"./presentation/pages/game/question/QuestionView": 29167,
	"./presentation/pages/game/question/QuestionView.tsx": 29167,
	"./presentation/pages/game/question/QuestionViewModel": 71722,
	"./presentation/pages/game/question/QuestionViewModel.ts": 71722,
	"./presentation/pages/home/DrawerItemView": 2921,
	"./presentation/pages/home/DrawerItemView.tsx": 2921,
	"./presentation/pages/home/HomeView": 50966,
	"./presentation/pages/home/HomeView.tsx": 50966,
	"./presentation/pages/home/HomeViewModel": 88453,
	"./presentation/pages/home/HomeViewModel.ts": 88453,
	"./presentation/pages/home/LanguageSelectView": 97825,
	"./presentation/pages/home/LanguageSelectView.tsx": 97825,
	"./presentation/pages/home/PlayGameFabView": 4654,
	"./presentation/pages/home/PlayGameFabView.tsx": 4654,
	"./presentation/pages/home/avatar/UserAvatarView": 70841,
	"./presentation/pages/home/avatar/UserAvatarView.tsx": 70841,
	"./presentation/pages/home/avatar/UserInfoViewModel": 50581,
	"./presentation/pages/home/avatar/UserInfoViewModel.ts": 50581,
	"./presentation/pages/landing/LandingView": 23010,
	"./presentation/pages/landing/LandingView.tsx": 23010,
	"./presentation/pages/landing/LandingViewModel": 83909,
	"./presentation/pages/landing/LandingViewModel.ts": 83909,
	"./presentation/pages/newGame/NewGameView": 36959,
	"./presentation/pages/newGame/NewGameView.tsx": 36959,
	"./presentation/pages/newGame/NewGameViewModel": 46589,
	"./presentation/pages/newGame/NewGameViewModel.ts": 46589,
	"./presentation/pages/newGame/chooseCategories/ChooseCategoriesView": 84351,
	"./presentation/pages/newGame/chooseCategories/ChooseCategoriesView.tsx": 84351,
	"./presentation/pages/newGame/chooseCategories/ChooseCategoryDetailsView": 41467,
	"./presentation/pages/newGame/chooseCategories/ChooseCategoryDetailsView.tsx": 41467,
	"./presentation/pages/newGame/chooseCategories/unlockCategory/UnlockCategoryView": 9443,
	"./presentation/pages/newGame/chooseCategories/unlockCategory/UnlockCategoryView.tsx": 9443,
	"./presentation/pages/newGame/chooseCategories/unlockCategory/UnlockCategoryViewModel": 12508,
	"./presentation/pages/newGame/chooseCategories/unlockCategory/UnlockCategoryViewModel.ts": 12508,
	"./presentation/pages/newGame/chooseLifelines/ChooseLifelinesView": 71535,
	"./presentation/pages/newGame/chooseLifelines/ChooseLifelinesView.tsx": 71535,
	"./presentation/pages/newGame/chooseTeamsName/ChooseTeamsNameView": 13452,
	"./presentation/pages/newGame/chooseTeamsName/ChooseTeamsNameView.tsx": 13452,
	"./presentation/pages/newGame/settingsPage/SettingsView": 43692,
	"./presentation/pages/newGame/settingsPage/SettingsView.tsx": 43692,
	"./presentation/pages/paymentStatus/PaymentStatusView": 74870,
	"./presentation/pages/paymentStatus/PaymentStatusView.tsx": 74870,
	"./presentation/pages/paymentStatus/PaymentStatusViewModel": 37113,
	"./presentation/pages/paymentStatus/PaymentStatusViewModel.ts": 37113,
	"./presentation/pages/play/PlayView": 25516,
	"./presentation/pages/play/PlayView.tsx": 25516,
	"./presentation/pages/playedGames/PlayedGamesView": 84894,
	"./presentation/pages/playedGames/PlayedGamesView.tsx": 84894,
	"./presentation/pages/playedGames/PlayedGamesViewModel": 5561,
	"./presentation/pages/playedGames/PlayedGamesViewModel.ts": 5561,
	"./presentation/pages/profile/ProfileView": 97462,
	"./presentation/pages/profile/ProfileView.tsx": 97462,
	"./presentation/pages/profile/ProfileViewModel": 78705,
	"./presentation/pages/profile/ProfileViewModel.ts": 78705,
	"./presentation/pages/qrcode/answers/QRCodeAnswersView": 30153,
	"./presentation/pages/qrcode/answers/QRCodeAnswersView.tsx": 30153,
	"./presentation/pages/qrcode/answers/QRCodeAnswersViewModel": 53014,
	"./presentation/pages/qrcode/answers/QRCodeAnswersViewModel.ts": 53014,
	"./presentation/pages/qrcode/canvas/BoardView": 69541,
	"./presentation/pages/qrcode/canvas/BoardView.tsx": 69541,
	"./presentation/pages/resetQuestions/ResetQuestionsView": 82372,
	"./presentation/pages/resetQuestions/ResetQuestionsView.tsx": 82372,
	"./presentation/pages/resetQuestions/ResetQuestionsViewModel": 40075,
	"./presentation/pages/resetQuestions/ResetQuestionsViewModel.ts": 40075,
	"./presentation/pages/transactions/TransactionsView": 74744,
	"./presentation/pages/transactions/TransactionsView.tsx": 74744,
	"./presentation/pages/transactions/TransactionsViewModel": 45501,
	"./presentation/pages/transactions/TransactionsViewModel.ts": 45501,
	"./presentation/pages/unfinishedGames/UnfinishedGamesView": 68254,
	"./presentation/pages/unfinishedGames/UnfinishedGamesView.tsx": 68254,
	"./presentation/pages/unfinishedGames/UnfinishedGamesViewModel": 7705,
	"./presentation/pages/unfinishedGames/UnfinishedGamesViewModel.ts": 7705,
	"./presentation/pages/unlockCode/UnlockCodeView": 7274,
	"./presentation/pages/unlockCode/UnlockCodeView.tsx": 7274,
	"./presentation/pages/unlockCode/UnlockCodeViewModel": 20717,
	"./presentation/pages/unlockCode/UnlockCodeViewModel.ts": 20717,
	"./presentation/routes/Router": 13503,
	"./presentation/routes/Router.tsx": 13503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25538;